import React from "react";
import { useTranslation } from "react-i18next";

import {
  StyledBox,
  StyledTableCell,
  StyledButton,
  StyledTableRow,
  StyledTableCellRow,
} from "./AccountIntegrationsSettings.styled";

import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  Paper,
  Typography,
} from "@components/base";


const AccountIntegrationsSettings: React.FC = () => {
  const { t } = useTranslation();

  return (
    <StyledBox>
      <Typography variant="h6" gutterBottom>
        {t("account.integrationsSources")}
      </Typography>
      <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
        <Table>
          <TableHead>
            <StyledTableRow>
              <StyledTableCell>{t("account.integrationsSource")}</StyledTableCell>
              <StyledTableCell>{t("account.integrationsStatus")}</StyledTableCell>
              <StyledTableCell>{t("account.integrationsActions")}</StyledTableCell>
            </StyledTableRow>
          </TableHead>
          <TableBody>
            <StyledTableRow>
              {/* eslint-disable-next-line react/jsx-no-literals */}
              <StyledTableCellRow>SAP</StyledTableCellRow>
              <StyledTableCellRow>
                {t("account.integrationsDisabled")}
              </StyledTableCellRow>
              <StyledTableCellRow>
                <StyledButton variant="outlined" color="success">
                  {t("account.integrationsConnect")}
                </StyledButton>
              </StyledTableCellRow>
            </StyledTableRow>
            <StyledTableRow>
              <StyledTableCellRow>Qlik view</StyledTableCellRow>
              <StyledTableCellRow>
                {t("account.integrationsDisabled")}
              </StyledTableCellRow>
              <StyledTableCellRow>
                <StyledButton variant="outlined" color="success">
                  {t("account.integrationsConnect")}
                </StyledButton>
              </StyledTableCellRow>
            </StyledTableRow>
            <StyledTableRow>
              <StyledTableCellRow>Flavius</StyledTableCellRow>
              <StyledTableCellRow>
                {t("account.integrationsDisabled")}
              </StyledTableCellRow>
              <StyledTableCellRow>
                <StyledButton variant="outlined" color="success">
                  {t("account.integrationsRequest")}
                </StyledButton>
              </StyledTableCellRow>
            </StyledTableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </StyledBox>
  );
};

export default AccountIntegrationsSettings;
